import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import QRCode from "react-qr-code";
import StudentInfo from "../FeeSystem/StudentInfo";
import moment from "moment";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import { calculateColumnTotal, getMonthName } from "../General/Utility";
const StatusWisePrint = () => {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [EndDate, setEndDate] = useState("");
  const [StartDate, setStartDate] = useState("");
  const [Wing, setWing] = useState("");
  const [Status, setStatus] = useState("");
  const [StatusName, setStatusName] = useState("");

  const [Reappear, setReappear] = useState("false");

  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [TotalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    document.title="Status Wise Print"

    setLoading(true);
    // Get the URL parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Retrieve individual parameter values
    const StartDate = urlParams.get("StartDate");
    const EndDate = urlParams.get("EndDate");
    const Wing_Id = urlParams.get("Wing");
    const Status = urlParams.get("Status");

    // const Reappear = urlParams.get('Reappear');

    setStartDate(StartDate);
    setEndDate(EndDate);
    setStatus(Status);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: 1,
      pageSize: 10000,
      StartDate: StartDate,
      EndDate: EndDate,
      Wing_Id: Wing,
      Status_Type_Id: Status,
      Reappear: Reappear,
    };

    //console.log("print data", data);

    var api_config = {
      method: "post",
      url: config.base_url + "/Reports/GetStatusChangeList",

      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    //console.log(data);
    axios(api_config)
      .then(function (response) {
        //console.log(response.data);
        setLedger(response.data.ListofRecords);
        setLoading(false);
        setTotalRecords(response.data.totalRecords);
        setTotalAmount(response.data.TotalAmount);
        setStatusName(response.data.statusName);
      })
      .catch(function (error) {
        //console.log(error);
      });
  }, []);

  const renderLedger = () => {
    if (listOfLedger.length > 0) {
      let count = 1;
      let countbreak = 1;
      return listOfLedger.map((item, index) => {
        return (
          <tr key={index}>
            <td>{item.Serial_No}</td>
            <td>{item.Registration_No}</td>
            <td>{item.Student_Name}</td>
            <td>
              {item.Wing_Name}, {item.Class_Name}, {item.Section_Name}
            </td>
            <td>{moment(item.Dated).format("DD/MM/YYYY")}</td>
            <td>{item.Remarks}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="20">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };

  return (
    <>
      <Page orientation="portrait" size="a4">
        <table className="table table-sm table-bordered table-print">
          <thead>
            <tr>
              <th colSpan={20}>
                <PrintHeader
                  title={`${StatusName} List From : ${StartDate} To ${EndDate}`}
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td className="text-center" colSpan="8">
                  <Spinner animation="border" role="status"></Spinner>
                </td>
              </tr>
            ) : (
              <>
                <tr>
                  <th>Sr.#</th>
                  <th>Reg. No</th>
                  <th style={{ width: "161px" }}>Student Name</th>
                  <th style={{ width: "168px" }}>Class Details</th>
                  <th>Dated</th>
                  <th>Remarks:</th>
                </tr>
                {renderLedger()}
              </>
            )}
          </tbody>
        </table>
      </Page>
    </>
  );
};

export default StatusWisePrint;
